import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import { UserCustomWindow } from '../user/user.types';
import { USER_CURRENT_STATUS } from '../../../shared/constants/userStatusConstants';

/* eslint-disable camelcase */
interface CustomWindow extends Window {
  current_user: UserCustomWindow['current_user'];
  METIERS_IS_ICP: Array<string>;
}
/* eslint-enable camelcase */

declare let window: CustomWindow;

let envName: string = '';
if (process.env.IS_PROD) {
  envName = '0lrhte/doctrine-prod';
} else if (process.env.IS_PREPROD) {
  envName = '0lrhte/doctrine-preprod';
}

export function startLogRocket() {
  const currentUser = window.current_user;

  const isUserMqlFreeTrial =
    currentUser &&
    window.METIERS_IS_ICP &&
    !!currentUser.metier &&
    window.METIERS_IS_ICP.includes(currentUser.metier) &&
    currentUser.status === USER_CURRENT_STATUS.FREE_TRIAL;

  const isUserPro =
    currentUser &&
    (currentUser.plan === 'PRO_PAYING' || currentUser.plan === 'ENTERPRISE');

  const shouldRecordOnLogRocket =
    (process.env.IS_PROD || process.env.IS_PREPROD) &&
    (isUserPro || isUserMqlFreeTrial);

  if (shouldRecordOnLogRocket) {
    LogRocket.init(envName);
    LogRocket.identify(String(currentUser.id), {
      plan: currentUser.plan,
    });

    LogRocket.getSessionURL(sessionURL => {
      if (window.Rollbar) {
        window.Rollbar.configure({
          transform(payload: { sessionURL: string }) {
            // eslint-disable-next-line
            payload.sessionURL = sessionURL;
          },
        });
      }
    });

    setupLogRocketReact(LogRocket);
    window.LogRocket = LogRocket;
  }
}
